export default {
    actions: {
        boot({ commit }, payload) {
            commit("PUSH_MAIN", payload);
            commit("PUSH_GENERAL");
            commit("PUSH_MAIL");
            commit("PUSH_LOGO");
            commit("PUSH_TERMS");
            commit("PUSH_CURRENCY");
            commit("PUSH_POSCONFIGS");
            commit("PUSH_BILLING");
        },
        async initialize({ dispatch }) {
            await window.axios.get("/sanctum/csrf-cookie");
            const response = await window.axios.post("/pull-app-configuration");

            dispatch("boot", response.data.configs);
            this.dispatch("auth/authenticatedUser", response.data);
        },
    },
    getters: {
        printSize(state) {
            return state.pos.printerWidth + " " + state.pos.printerHight;
        },
        pos(state) {
            return state.pos;
        },
        volume(state) {
            return state.general.volume;
        },
        billing(state) {
            return state.billing;
        },
        currency(state) {
            return state.currency;
        },
        demo(state) {
            return state.main.demo;
        },
        general(state) {
            return state.general;
        },
        logo(state) {
            return state.logo;
        },
        logoBill(state) {
            return state.logoBill;
        },
        mail(state) {
            return state.mail;
        },
        overall(state) {
            return state.main;
        },
        rtl(state) {
            return state.main.rtl;
        },
        terms(state) {
            return state.terms;
        },
        theme(state) {
            return state.main.theme;
        },
        version(state) {
            return state.main.version;
        },
    },
    mutations: {
        PUSH_POSCONFIGS(state) {
            state.pos.printerWidth = state.main.printerWidth;
            state.pos.printerHight = state.main.printerHight;
            state.pos.overSelling = state.main.overSelling;
            state.pos.productSkin = state.main.productSkin;
            state.pos.productName = state.main.productName;
            state.pos.defaultTaxRate = state.main.defaultTaxRate;
            state.pos.defaultDiscountRate = state.main.defaultDiscountRate;
            state.pos.posProductsLimit = state.main.posProductsLimit;
            state.pos.stopDiscount = state.main.stopDiscount;
            state.pos.focusIntervel = state.main.focusIntervel;
            state.pos.isTaxIncluded = state.main.isTaxIncluded;
            state.pos.barcodeContainsDigits = state.main.barcodeContainsDigits;
            state.pos.scanningSensitivity = state.main.scanningSensitivity;
            state.pos.posAutoLoadProducts = state.main.posAutoLoadProducts;
        },
        PUSH_CURRENCY(state) {
            state.currency.symbol = state.main.symbol;
            state.currency.symbolOnLeft = state.main.symbolOnLeft;
            state.currency.spaceBetweenAmountAndSymbol =
                state.main.spaceBetweenAmountAndSymbol;
        },
        PUSH_GENERAL(state) {
            state.general.logoWidth = state.main.logoWidth;
            state.general.logoHight = state.main.logoHight;
            state.general.site_name = state.main.site_name;
            state.general.phone = state.main.phone;
            state.general.address_1 = state.main.address_1;
            state.general.address_2 = state.main.address_2;
            state.general.address_3 = state.main.address_3;
            state.general.symbol = state.main.symbol;
            state.general.symbolOnLeft = state.main.symbolOnLeft;
            state.general.rtl = state.main.rtl;
            state.general.theme = state.main.theme;
            state.general.spaceBetweenAmountAndSymbol =
                state.main.spaceBetweenAmountAndSymbol;
            state.general.volume = state.main.volume;
            state.general.dateFormat = state.main.dateFormat;
            state.general.ownnerInfo = state.main.ownnerInfo;
        },
        PUSH_LOGO(state) {
            state.logo = state.main.logo;
            state.logoBill = state.main.logoBill;
        },
        PUSH_MAIL(state) {
            state.mail.from_email = state.main.from_email;
            state.mail.reply_email = state.main.reply_email;
            state.mail.mail_driver = state.main.mail_driver;
            state.mail.mail_host = state.main.mail_host;
            state.mail.mail_port = state.main.mail_port;
            state.mail.mail_user = state.main.mail_user;
            state.mail.mail_password = state.main.mail_password;
            state.mail.mail_encryption = state.main.mail_encryption;
        },
        PUSH_MAIN(state, main) {
            state.main = main;
        },
        PUSH_BILLING(state) {
            state.billing.billLogo = state.main.billLogo;
            state.billing.billLogoWidth = state.main.billLogoWidth;
            state.billing.billLogoHeight = state.main.billLogoHeight;
            state.billing.billAppName = state.main.billAppName;
            state.billing.billAddress = state.main.billAddress;
            state.billing.billPhone = state.main.billPhone;
            state.billing.billType = state.main.billType;
            state.billing.billBarcode = state.main.billBarcode;
            state.billing.billDateTime = state.main.billDateTime;
            state.billing.billRefrence = state.main.billRefrence;
            state.billing.billItemFontSize = state.main.billItemFontSize;
            state.billing.billItemQtyFontSize = state.main.billItemQtyFontSize;
            state.billing.billDateTimeTransFontSize =
                state.main.billDateTimeTransFontSize;
            state.billing.billHrFontSize = state.main.billHrFontSize;
            state.billing.billTermsFontSize = state.main.billTermsFontSize;
            state.billing.billtextFlow = state.main.billtextFlow;
            state.billing.billItemUnit = state.main.billItemUnit;
            state.billing.billBy = state.main.billBy;
            state.billing.billLogoRound = state.main.billLogoRound;
        },
        PUSH_TERMS(state) {
            state.terms.saleTerms = state.main.saleTerms;
            state.terms.refundTerms = state.main.refundTerms;
            state.terms.purhcaseTerms = state.main.purhcaseTerms;
            state.terms.repairTerms = state.main.repairTerms;
            state.terms.customTerms = state.main.customTerms;
            state.terms.billTerms = state.main.billTerms;
            state.terms.ownnerInfo = state.main.ownnerInfo;
        },
    },
    namespaced: true,
    state: {
        pos: {},
        currency: {},
        general: {},
        logo: "",
        logoBill: "",
        mail: {},
        main: {},
        terms: [],
        billing: {},
    },
};
